/**
 * For requests whose answers replace one another, such as a list's reload after each save: start() is called as each
 * request is sent, and the function it returns says whether a later one has been sent since, so this answer is stale.
 */
export const newestOnly = () => {
  let latest = 0;
  return {
    start: () => {
      const mine = ++latest;
      return () => mine !== latest;
    },
  };
};
